import { gql, TypedDocumentNode } from "@apollo/client";

import { Query, QueryIntentChatConversationArgs } from "types/generated";
import { PickInner } from "types/helpers";

type ChatConversationTranscriptData = {
  intentChatConversation: PickInner<Query["intentChatConversation"], "id" | "transcript">;
};

export const CHAT_CONVERSATION_TRANSCRIPT: TypedDocumentNode<
  ChatConversationTranscriptData,
  QueryIntentChatConversationArgs
> = gql`
  query ChatConversationTranscript($id: ID!) {
    intentChatConversation(id: $id) {
      id
      transcript
    }
  }
`;
